<section>
  <div class="border_container">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style p-2">
      <div [hidden]="!isFormView" class="col-lg-12 col-md-12 col-sm-12 col-12 border py-1 px-2 mb-2">
        <form [formGroup]="formChargeAccountConcept">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-8 col-12">
              <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
                [list]="listConceptInvoicing" [disabled]="true"> </app-custom-autocomplete>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="value" [labelText]="'Valor'"
                [disabled]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="discountRate" [labelText]="'% Dcto.'" [required]="true"
                (onChangeNumber)="changeDiscountRate()"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-4 col-6">
              <app-custom-input-decimal formControlName="discountValue" [labelText]="'Vr. Dcto.'" [required]="true"
                (onChangeNumber)="changeDiscountValue()"></app-custom-input-decimal>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-end gap-2">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledActions" (onClick)="send()"></app-custom-button>
              <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="cancel()"></app-custom-button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-table [headers]="header" [data]="data" [actions]="tableActions"
          (onPageChange)="onPageChange($event)" (onRecoverData)="getInvoiceConceptsByInvoiceIdWithPagination()"
          (onAction)="onAction($event)"></app-custom-table>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2">
        <app-custom-button [label]="'Salir'" [severity]="'danger'" (onClick)="close()"></app-custom-button>
      </div>
    </div>
  </div>
</section>